import { Box, ModalHeader } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useProposalAdjustment } from '../../../../hooks/adjustments/proposal'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { FormConfig } from '../../../../state/configuration'
import { FormData, FormDisabled } from '../../../formBuilder'

export interface ProposalConfirmationModalProps {
  form: FormConfig
  data: FormData
  onComplete: () => void
}

const tKey = TKey('components.proposal-confirmation-modal')

export const ProposalConfirmationModal: FunctionComponent<
  ProposalConfirmationModalProps
> = ({ form, data, onComplete }) => {
  const { t } = useWriskTranslation()

  const onSubmitAdjustment = useProposalAdjustment({
    form,
    applyRating: false,
    onComplete,
  })

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} subheader={t(tKey('subheader'))} />
      <FormDisabled
        id='proposalConfirmation'
        data={data}
        config={form}
        onSubmit={onSubmitAdjustment.execute}
        loading={onSubmitAdjustment.loading}
        tKey={TExtends(tKey, 'inputs')}
        t={t}
      />
    </Box>
  )
}
